module.exports = __webpack_public_path__ + "static/img/CI.c9dafc9b.svg";